import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';
import { MediaData } from '@/api/ux_logs';

export type State = {
  mediaData: MediaData[];
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.mediaData = [];
}

const getters: GetterTree<State, RootState> = {
  mediaData: (state: State): MediaData[] => state.mediaData
};

const mutations: MutationTree<State> = {
  setMediaDeviceInfo(state: State, payload: { devices: MediaDeviceInfo[] }): void {
    state.mediaData = payload.devices
      .filter((device: MediaDeviceInfo): boolean => device.kind === 'videoinput')
      .slice(0, 30)
      .map((device: MediaDeviceInfo): MediaData => {
        const labelEncoded: string = window.btoa(window.encodeURIComponent(device.label));
        // const labelDecoded: string = window.decodeURIComponent(window.atob(labelEncoded));
        return [device.deviceId, device.kind, labelEncoded, device.groupId];
      });
  },

  clearState(state: State): void {
    clearState(state);
  }
};

const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  }
};

export const cameraMediaData: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
